import { apiRequest, API_BASE_URL } from './api.config';
import { ApiResponse } from '@utilities/types';

export interface LiningOption {
    id: string;
    name: string;
    image: string;
}

export interface LiningCategory {
    id: string;
    label: string;
    options: LiningOption[];
}

export async function getLiningCatalog(): Promise<LiningCategory[]> {
    const res = await apiRequest<ApiResponse<{ categories: LiningCategory[] }>>('/linings/catalog', { cache: 'no-store' });
    const staticBase = (API_BASE_URL || '').replace(/\/api\/v1$/, '');
    return (res.data.categories || []).map((category) => ({
        ...category,
        options: category.options.map((option) => ({ ...option, image: `${staticBase}${option.image}` })),
    }));
}
